import React from "react";
import { Link } from "react-router-dom";
import { BRAND } from "@/lib/brand";

export const LogoMark = ({ size = 44 }) => (
  <img src={BRAND.icon} alt="PinMyDates logo" width={size} height={size}
    className="rounded-[12px] shadow-[0_6px_16px_-6px_rgba(195,0,119,.55)]" style={{ width: size, height: size }} />
);

export const Wordmark = ({ to = "/", testid = "brand-wordmark" }) => (
  <Link to={to} className="flex items-center gap-3" data-testid={testid}>
    <LogoMark />
    <span className="leading-tight">
      <span className="block text-[1.2rem] font-extrabold tracking-tight">
        <span className="text-[var(--pm-ink)]">PinMy</span><span className="pm-gradient-text">Dates</span>
      </span>
      <span className="block text-[0.72rem] font-bold text-[#A0136E]">{BRAND.tagline}</span>
    </span>
  </Link>
);
